import React from "react";
import './LandingPage.css'
import email from './assets/icons8-email-50 (2).png'
import linkedin from './assets/icons8-linkedin-50 (4).png'
import github from './assets/icons8-github-50 (5).png'
import { Player } from '@lottiefiles/react-lottie-player';
import { Link } from 'react-scroll'

const LandingPage = () => {
  return (
    <section className='landing-container'>
      <div className='title-container'>
        <h1 className='name'>GEENA JACKSON</h1>
        <p className='title'>SOFTWARE ENGINEER</p>
        <div className="icon-container">
          <a href="mailto:gjacks303@gmail.com" target='blank'>
            <img src={email} alt='email icon' className='email-icon' />
          </a>
          <a href="https://www.linkedin.com/in/geena-jackson/" target='blank'>
            <img src={linkedin} alt='linkedin icon' className='linkedin-icon' />
          </a>
          <a href="https://github.com/gjax78" target='blank'>
            <img src={github} alt='github icon' className='github-icon' />
          </a>
        </div>
      </div>
      <Link
        className="lottie-link" 
        to="about" 
        spy={true} 
        smooth={true} 
        offset={-30} 
        duration={500} 
      >
      <Player
        src='https://lottie.host/48d44c3e-c913-4437-84c3-9dbc942ddef0/rlP2Nbxod3.json'
        className="player"
        loop
        autoplay
      />
      </Link>
    </section>
  )
}

export default LandingPage